Namespace 'Customer.Sessions'

class Customer.Sessions.LocalStorageSessionsRepository extends Backbone.Model

  storeCurrentSession:(customerSession) ->
    currentLocalOperatorSessions = @getSessionFromLocalStorage(customerSession)
    if @isNewSession(customerSession, currentLocalOperatorSessions)
      currentLocalOperatorSessions.push(customerSession)
      @_save(customerSession.operatorId, currentLocalOperatorSessions)

  getSessionFromLocalStorage:(customerSession) ->
    operatorSessionKey = @_getOperatorSessionKey(customerSession.operatorId)
    currentLocalOperatorSessions = JSON.parse(localStorage.getItem(operatorSessionKey))
    if currentLocalOperatorSessions
      operatorSessions = currentLocalOperatorSessions
    else
      operatorSessions = []
    operatorSessions

  isNewSession:(customerSession, operatorSessions)->
    filteredOperatorSessions = _.filter(operatorSessions, (session) => (@_equals(session, customerSession)) )
    filteredOperatorSessions.length <= 0

  updateSessionTimestamp:(customerSession, datetime) ->
    currentLocalOperatorSessions = @getSessionFromLocalStorage(customerSession)
    index = _.findIndex(currentLocalOperatorSessions, (session) => @_equals(session, customerSession))
    if index != -1
      currentLocalOperatorSessions[index].last_activity_time = datetime
      @_save(customerSession.operatorId, currentLocalOperatorSessions)

  removeCurrentSession:(customerSession) ->
    currentLocalOperatorSessions = @getSessionFromLocalStorage(customerSession)
    sessionsWithoutCurrentSession = _.filter(currentLocalOperatorSessions, (session) => (not @_equals(session, customerSession)) )
    data = new FormData()
    data.append('operator_id', customerSession.operatorId);
    data.append('customer_session_id', customerSession.customerSessionId);
    if sessionsWithoutCurrentSession.length > 0
      @_save(customerSession.operatorId, sessionsWithoutCurrentSession)
      data.append('is_last_session', false)
    else
      localStorage.removeItem(@_getOperatorSessionKey(customerSession.operatorId))
      data.append('is_last_session', true)
    @_notifySessionClosureToServer(data)

  _equals:(session, anotherSession)->
    session.customer_session_id == anotherSession.customerSessionId

  _getOperatorSessionKey:(operatorId) ->
    return 'operator_' + operatorId

  _notifySessionClosureToServer:(data)->
    data.append("authenticity_token", authToken())
    navigator.sendBeacon("/customer/dashboard/close_customer_session", data);

  _save: (operatorId, sessions)->
    localStorage.setItem(@_getOperatorSessionKey(operatorId), JSON.stringify(sessions))
